import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=477c22c1&scoped=true&"
import script from "./ContactButton.vue?vue&type=script&lang=js&"
export * from "./ContactButton.vue?vue&type=script&lang=js&"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=477c22c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c22c1",
  null
  
)

export default component.exports